import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  appBar: {
    height: '50px',
    minHeight: '50px', // overwrite appBar default minHeight
  },
});
